// French translations. Keys must mirror en.js exactly.
const fr = {
  // --- Common UI strings ---------------------------------------------------
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.add': 'Ajouter',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.deactivate': 'Désactiver',
  'common.activate': 'Activer',
  'common.search': 'Rechercher',
  'common.loading': 'Chargement...',
  'common.actions': 'Actions',
  'common.status': 'Statut',
  'common.active': 'Actif',
  'common.inactive': 'Inactif',
  'common.showInactive': 'Afficher les inactifs',
  'common.noEntries': 'Aucune entrée',
  'common.saving': 'Enregistrement...',
  'common.required': 'requis',
  'common.code': 'Code',
  'common.name': 'Nom',
  'common.description': 'Description',
  'common.welcome': 'Bienvenue',
  'common.logout': 'Déconnexion Sécurisée',
  'common.guest': 'Invité',
  'common.appName': 'RestoBoxx',
  'common.currentLocation': 'Établissement actuel',
  'common.showSidebar': 'Afficher le menu latéral',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'userMenu.preferences': 'Préférences',
  'userMenu.switchOutlet': 'Changer d\'établissement',
  'userMenu.noOutlets': 'Aucun autre établissement',
  'header.help': 'Aide & InTutor',
  'header.fullscreen': 'Plein écran',
  'header.exitFullscreen': 'Quitter le plein écran',
  'search.menus': 'Rechercher un menu…',
  'search.noMatch': 'Aucun menu ne correspond à « {q} ».',
  'common.saved': 'Enregistré',
  'common.savedDescription': 'Vos modifications ont été appliquées.',
  'common.saveFailed': 'Échec de l\'enregistrement',

  // --- Language switcher ---------------------------------------------------
  'language.english': 'Anglais',
  'language.french': 'Français',
  'language.label': 'Langue',

  // --- Sidebar / navigation ------------------------------------------------
  'nav.overview': 'Aperçu',
  'nav.dashboard': 'Tableau de bord',
  'nav.reports': 'Rapports',
  'nav.menu': 'Menu',
  'nav.menus': 'Menus',
  'nav.allMenus': 'Tous les menus',
  'nav.createMenu': 'Créer un menu',
  'nav.allDishes': 'Tous les plats',
  'nav.addDish': 'Ajouter un plat',
  'nav.orders': 'Commandes',
  'nav.manageOrders': 'Créer une commande',
  'nav.inventory': 'Stock',
  'nav.records': 'Registres',
  'nav.itemTracking': 'Suivi des articles',
  'nav.purchase': 'Achats',
  'nav.bar': 'Bar',
  'nav.barInventory': 'Inventaire du bar',
  'nav.liquorManagement': 'Gestion des alcools',
  'nav.liquorConsumption': 'Consommation',
  'nav.liquorStock': 'Stock',
  'nav.liquorTopSelling': 'Meilleures ventes',
  'nav.liquorTracking': 'Suivi des alcools',
  'nav.seating': 'Salle',
  'nav.layout': 'Plan de salle',
  'nav.designer': 'Concepteur',
  'nav.tableSelection': 'Sélection des tables',
  'nav.viewTables': 'Voir les tables',
  'nav.reservations': 'Réservations',
  'nav.staff': 'Personnel',
  'nav.allStaff': 'Liste du personnel',
  'nav.staffRoles': 'Rôles du personnel',
  'nav.userSessions': 'Sessions utilisateurs',
  'nav.settings': 'Paramètres',
  'nav.companyProfile': 'Profil de l\'entreprise',
  'nav.restaurantGroups': 'Groupes de restaurants',
  'nav.locations': 'Emplacements',
  'nav.finderPlaces': 'Lieux (Près de moi)',
  'nav.kioskSettings': 'Paramètres des bornes',
  'nav.dataDisplay': 'Affichage des données',
  'nav.masterData': 'Données de référence',
  'nav.display': 'Apparence',

  // --- Settings: Data Display page -----------------------------------------
  'dataDisplay.title': 'Affichage des données',
  'dataDisplay.subtitle': 'Définissez comment les dates, heures et valeurs par défaut sont affichées dans tout le système.',
  'dataDisplay.dateTimeCard': 'Format de date et d\'heure',
  'dataDisplay.dateTimeCardSubtitle': 'Ces paramètres s\'appliquent partout où une date ou une heure est affichée.',
  'dataDisplay.timezone': 'Fuseau horaire',
  'dataDisplay.dateFormat': 'Format de date',
  'dataDisplay.timeFormat': 'Format d\'heure',
  'dataDisplay.defaultsCard': 'Sélections par défaut',
  'dataDisplay.defaultsCardSubtitle': 'Choisissez les valeurs par défaut des données de référence pour les nouveaux enregistrements et rapports.',
  'dataDisplay.defaultCountry': 'Pays par défaut',
  'dataDisplay.defaultCurrency': 'Devise par défaut',
  'dataDisplay.defaultLanguage': 'Langue par défaut',
  'dataDisplay.livePreview': 'Aperçu en direct',
  'dataDisplay.livePreviewSubtitle': 'Voici comment l\'heure actuelle sera affichée avec ces paramètres.',
  'dataDisplay.date': 'Date',
  'dataDisplay.time': 'Heure',
  'dataDisplay.dateAndTime': 'Date + Heure',
  'dataDisplay.savePreferences': 'Enregistrer les préférences',
  'dataDisplay.placeholder.selectTimezone': 'Sélectionner un fuseau horaire',
  'dataDisplay.placeholder.selectDateFormat': 'Sélectionner un format de date',
  'dataDisplay.placeholder.selectTimeFormat': 'Sélectionner un format d\'heure',
  'dataDisplay.placeholder.selectCountry': 'Sélectionner un pays',
  'dataDisplay.placeholder.selectCurrency': 'Sélectionner une devise',
  'dataDisplay.placeholder.selectLanguage': 'Sélectionner une langue',
  'dataDisplay.placeholder.selectType': 'Sélectionner un type',
  'dataDisplay.loadOptionsFailed': 'Échec du chargement des options',

  // --- Settings: Master Data page ------------------------------------------
  'masters.title': 'Données de référence',
  'masters.subtitle': 'Gérez les listes partagées utilisées dans tout le système.',
  'masters.tab.countries': 'Pays',
  'masters.tab.currencies': 'Devises',
  'masters.tab.languages': 'Langues',
  'masters.tab.sectionTypes': 'Types de section',
  'masters.column.code': 'Code',
  'masters.column.name': 'Nom',
  'masters.column.dialCode': 'Indicatif',
  'masters.column.symbol': 'Symbole',
  'masters.column.nativeName': 'Nom natif',
  'masters.column.description': 'Description',
  'masters.searchPlaceholder': 'Rechercher dans {tab}...',
  'masters.addButton': 'Ajouter {item}',
  'masters.editTitle': 'Modifier {item}',
  'masters.addTitle': 'Ajouter {item}',
  'masters.singular.country': 'un pays',
  'masters.singular.currency': 'une devise',
  'masters.singular.language': 'une langue',
  'masters.singular.sectionType': 'un type de section',
  'masters.loadFailed': 'Échec du chargement',
  'masters.added': 'Ajouté',
  'masters.updated': 'Mis à jour',

  // Add / Edit Dish page - page header.
  'addDish.pageHeader.title.add': 'Ajouter : {kind}',
  'addDish.pageHeader.title.edit': 'Modifier : {kind}',
  'addDish.pageHeader.description.edit': 'Mettez à jour les détails, variantes et attributs du plat.',
  'addDish.pageHeader.kind.dish': 'Plat',
  'addDish.pageHeader.kind.liquor': 'Alcool',
  'addDish.pageHeader.kind.beverage': 'Boisson',
  'addDish.pageHeader.kind.addon': 'Supplément',
  'addDish.pageHeader.kind.combo': 'Combo',
  'addDish.pageHeader.backButton': 'Retour à tous les plats',
  'addDish.pageHeader.mode.editing': 'En modification',
  'addDish.pageHeader.draft': 'Brouillon',
  'addDish.pageHeader.sku': 'SKU',
  'addDish.pageHeader.kindLocked': 'Type d’article — fixé à la création',
  'addDish.pageHeader.status.active': 'Actif',
  'addDish.pageHeader.status.inactive': 'Inactif',
  'addDish.pageHeader.statusTitle.active': 'Actuellement actif — cliquez pour désactiver',
  'addDish.pageHeader.statusTitle.inactive': 'Actuellement inactif — cliquez pour activer',

  // Type selector
  'addDish.typeSelector.dish.label': 'Plat',
  'addDish.typeSelector.dish.desc': 'Un article de menu standard',
  'addDish.typeSelector.beverage.label': 'Boisson',
  'addDish.typeSelector.beverage.desc': 'Café, milkshakes, jus, cocktails sans alcool',
  'addDish.typeSelector.addon.label': 'Supplément',
  'addDish.typeSelector.addon.desc': 'Fromage en plus, Nutella, garniture',
  'addDish.typeSelector.combo.label': 'Combo',
  'addDish.typeSelector.combo.desc': 'Regroupez des articles existants à un prix fixe',
  'addDish.typeSelector.store_bought.label': 'Acheté en magasin',
  'addDish.typeSelector.store_bought.desc': 'Acheté à l\'extérieur, servi tel quel — boissons fraîches, chips',
  'addDish.typeSelector.bakery.label': 'Boulangerie',
  'addDish.typeSelector.bakery.desc': 'Pains, pâtisseries, gâteaux',
  'addDish.typeSelector.liquor.label': 'Alcool',
  'addDish.typeSelector.liquor.desc': 'Boissons alcoolisées — bière, vin, spiritueux',

  // Basic info card
  'addDish.basicInfo.title': 'Informations de base',
  'addDish.basicInfo.name.label': 'Nom',
  'addDish.basicInfo.name.placeholder': 'ex. Nouilles',
  // Espace réservé du nom selon le type — l'exemple correspond à ce qu'on crée.
  'addDish.basicInfo.namePlaceholder.dish': 'ex. Nouilles',
  'addDish.basicInfo.namePlaceholder.liquor': 'ex. Whisky',
  'addDish.basicInfo.namePlaceholder.beverage': 'ex. Limonade',
  'addDish.basicInfo.namePlaceholder.addon': 'ex. Supplément fromage',
  'addDish.basicInfo.namePlaceholder.combo': 'ex. Menu déjeuner',
  'addDish.basicInfo.category.label': 'Catégorie',
  'addDish.basicInfo.subcategory.label': 'Sous-catégorie',
  'addDish.basicInfo.subcategory.placeholder': 'Sélectionner une sous-catégorie (facultatif)',
  'addDish.basicInfo.subcategory.empty.withCategory': 'Aucune sous-catégorie sous cette catégorie.',
  'addDish.basicInfo.subcategory.empty.noCategory': 'Aucune sous-catégorie.',
  'addDish.basicInfo.description.label': 'Description',
  'addDish.basicInfo.description.placeholder': 'Décrivez le plat...',
  'addDish.basicInfo.locations.label': 'Emplacements',
  'addDish.basicInfo.tags.label': 'Étiquettes',
  'addDish.basicInfo.tags.empty': 'Aucune étiquette — créez-en sous Paramètres → Données de référence → Étiquettes.',
  'addDish.basicInfo.prepTime.label': 'Préparation (min)',
  'addDish.basicInfo.cookTime.label': 'Cuisson (min)',
  'addDish.basicInfo.total.label': 'Total',
  'addDish.basicInfo.total.unit': 'min',

  // Kitchen Operations card
  'addDish.kitchenOps.title': 'Opérations cuisine',
  'addDish.kitchenOps.station.label': 'Poste de cuisson',
  'addDish.kitchenOps.station.placeholder': 'ex. poste à Dosa, Tandoor…',
  'addDish.kitchenOps.platingNote.label': 'Note de dressage',
  'addDish.kitchenOps.platingNote.placeholder': 'ex. Servir plié…',
  'addDish.kitchenOps.servingVessel.label': 'Vaisselle de service',
  'addDish.kitchenOps.servingVessel.placeholder': 'ex. Assiette en inox…',

  // Attributes card
  'addDish.attributes.title': 'Attributs',
  'addDish.attributes.spicy.label': 'Piquant',
  'addDish.attributes.spicy.less': 'Peu',
  'addDish.attributes.spicy.normal': 'Normal',
  'addDish.attributes.spicy.extra': 'Très',
  'addDish.attributes.style.label': 'Style',
  'addDish.attributes.style.dry': 'Sec',
  'addDish.attributes.style.semiGravy': 'Demi-sauce',
  'addDish.attributes.style.gravy': 'En sauce',
  'addDish.attributes.diet.label': 'Régime',
  'addDish.attributes.diet.veg': 'Végé',
  'addDish.attributes.diet.nonveg': 'Non-végé',
  'addDish.attributes.diet.vegan': 'Végan',
  'addDish.attributes.nonvegType.label': 'Type non-végé',
  'addDish.attributes.nonvegType.empty': 'Aucun type — utilisez le bouton +.',
  'addDish.attributes.serve.label': 'Servir',
  'addDish.attributes.serve.hot': '☕ Chaud',
  'addDish.attributes.serve.cold': '🧊 Froid',

  // Ingredients picker
  'addDish.ingredients.title': 'Ingrédients',
  'addDish.ingredients.search.placeholder': 'Rechercher des ingrédients…',
  'addDish.ingredients.allergenNote': 'Les ingrédients allergènes sont mis en évidence.',
  'addDish.ingredients.allergenLabel': 'Allergènes :',
  'addDish.ingredients.empty': 'Aucun ingrédient — utilisez le + ci-dessus pour en ajouter.',

  // Garnishes picker
  'addDish.garnishes.title': 'Garnitures',
  'addDish.garnishes.search.placeholder': 'Rechercher des garnitures…',
  'addDish.garnishes.note': 'Choisies depuis la liste des ingrédients.',
  'addDish.garnishes.tagged': 'Étiquetées :',
  'addDish.garnishes.empty': 'Aucun ingrédient à choisir. Ajoutez-en un avec le + ci-dessus.',

  // Dish image card
  'addDish.dishImage.title': 'Image du plat',
  'addDish.dishImage.changeImage': 'Changer l\'image',
  'addDish.dishImage.chooseImage': 'Choisir une image',
  'addDish.dishImage.fileInfo': 'PNG, JPG jusqu\'à 5 Mo',
  'addDish.dishImage.remove': 'Supprimer',

  // Take Away card
  'addDish.takeaway.title': 'À emporter',
  'addDish.takeaway.toggle.on': 'Autorisé',
  'addDish.takeaway.toggle.off': 'Désactivé',
  'addDish.takeaway.cutlery.label': 'Couverts',
  'addDish.takeaway.cutlery.empty': 'Aucune option de couverts — ajoutez-en avec le + .',
  'addDish.takeaway.instructions.label': 'Instructions',
  'addDish.takeaway.instructions.placeholder': 'ex. Emballer la sauce séparément…',
  'addDish.takeaway.descField.label': 'Description',
  'addDish.takeaway.descField.placeholder': 'Court message affiché au client…',

  // Variants table
  'addDish.variants.title': 'Variantes',
  'addDish.variants.subtitle': 'Ajoutez différentes tailles ou quantités avec tarification',
  'addDish.variants.addRow': 'Ajouter une ligne',
  'addDish.variants.table.size': 'TAILLE',
  'addDish.variants.table.unit': 'UNITÉ',
  'addDish.variants.table.displayName': 'NOM AFFICHÉ',
  'addDish.variants.table.qtyPieces': 'QTÉ / PIÈCES',
  'addDish.variants.table.serves': 'PERSONNES',
  'addDish.variants.table.calories': 'CALORIES',
  'addDish.variants.displayName.dish': 'Nom du plat',
  'addDish.variants.displayName.custom': 'Personnalisé…',
  'addDish.variants.displayName.customPlaceholder': 'ex. Format familial',
  'addDish.variants.caloriesPlaceholder': 'kcal',
  'addDish.variants.removeTooltip.disabled': 'Au moins une variante est requise',
  'addDish.variants.removeTooltip.enabled': 'Supprimer cette ligne',
  'addDish.variants.selectSize': 'Sélectionner une taille',
  'addDish.variants.chooseLabel': 'Choisir un libellé',

  // Price matrix
  'addDish.priceMatrix.title': 'Prix · matrice variante × emplacement',
  'addDish.priceMatrix.description': 'Les variantes sont en colonnes, les emplacements en lignes. Chaque cellule contient les prix Normal, À emporter et Livraison pour que le même plat varie par branche et par canal.',
  'addDish.priceMatrix.seasonal': 'Saisonnier',
  'addDish.priceMatrix.seasonalTooltip.active': 'Saisonnier — tous les prix sont verrouillés. Décochez pour saisir des prix.',
  'addDish.priceMatrix.seasonalTooltip.inactive': 'Marquer ce plat comme saisonnier — verrouille tous les prix sur toutes les variantes et emplacements.',
  'addDish.priceMatrix.seasonalLocked': 'prix verrouillés',
  'addDish.priceMatrix.header.legend': 'Emplacement ↓ · Variante →',
  'addDish.priceMatrix.header.cells': 'Cellules : Normal · À emporter · Livraison',
  'addDish.priceMatrix.column.base': 'BASE',
  'addDish.priceMatrix.column.seasonal': 'SAISONNIER',
  'addDish.priceMatrix.column.seasonalTooltip': 'Saisonnier — prix fixé chaque jour pour chaque emplacement',
  'addDish.priceMatrix.empty': 'Aucun emplacement sélectionné — choisissez des branches dans la carte Emplacements ci-dessus, puis fixez les prix par branche ici.',
  'addDish.priceMatrix.price.norm': 'NORM',
  'addDish.priceMatrix.price.taway': 'EMP.',
  'addDish.priceMatrix.price.deliv': 'LIVR.',
  'addDish.priceMatrix.placeholder.seasonal': 'Saisonnier',
  'addDish.priceMatrix.tipFooter': 'Astuce : laissez À emporter / Livraison vide pour facturer le prix Normal sur ces canaux. Activer SAISONNIER sur une colonne de variante verrouille tous les prix de cette variante.',

  // Recipe matrix
  'addDish.recipeMatrix.title': 'Recette · matrice de variantes',
  'addDish.recipeMatrix.description': 'Les variantes sont en colonnes, les ingrédients en lignes. Modifiez chaque cellule en ligne ; le ×ratio montre la comparaison avec la base.',
  'addDish.recipeMatrix.header.legend': 'Matrice de variantes',
  'addDish.recipeMatrix.header.instructions': 'Modifiez n\'importe quelle cellule · ↹ pour naviguer',
  'addDish.recipeMatrix.empty': 'Aucun ingrédient dans la matrice — choisissez-en un ci-dessous pour démarrer la recette.',
  'addDish.recipeMatrix.addRow.placeholder': '+ Ajouter une ligne d\'ingrédient…',
  'addDish.recipeMatrix.removeTooltip': 'Retirer cet ingrédient de toutes les variantes',
  'addDish.recipeMatrix.noIngredientsMaster': 'Aucun ingrédient dans la liste de référence — créez-en d\'abord.',
  'addDish.recipeMatrix.allUsed': 'Tous les ingrédients disponibles sont dans la matrice.',
  'addDish.recipeMatrix.tipFooter': 'Les choix sont ajoutés à chaque variante — réglez la quantité par colonne.',

  // Complimentary matrix
  'addDish.complimentary.title': 'Offerts · matrice de variantes',
  'addDish.complimentary.description': 'Les variantes sont en colonnes, les articles offerts en lignes. Cliquez sur une cellule pour offrir cet article avec une variante.',
  'addDish.complimentary.header.legend': 'Matrice des articles offerts',
  'addDish.complimentary.header.instructions': 'Cliquez sur une cellule pour basculer',
  'addDish.complimentary.empty': 'Aucun article offert dans la matrice — choisissez-en un ci-dessous pour démarrer.',
  'addDish.complimentary.add.placeholder': '+ Ajouter un article offert…',
  'addDish.complimentary.bundledFree': 'offert',
  'addDish.complimentary.cellOnTooltip': 'Inclus offert — cliquez pour retirer',
  'addDish.complimentary.cellOffTooltip': 'Cliquez pour offrir avec cette variante',
  'addDish.complimentary.removeTooltip': 'Retirer cet article de toutes les variantes',
  'addDish.complimentary.allergensIn': 'Allergènes dans ce plat :',
  'addDish.complimentary.groupAddons': 'Suppléments',
  'addDish.complimentary.groupDishes': 'Plats',
  'addDish.complimentary.groupBeverages': 'Boissons',
  'addDish.complimentary.groupCombos': 'Combos',
  'addDish.complimentary.noneAvailable': 'Aucun autre plat/supplément/boisson/combo disponible à grouper.',
  'addDish.complimentary.allInMatrix': 'Tous les articles disponibles sont déjà dans la matrice.',
  'addDish.complimentary.tipFooter': 'L\'article choisi est ajouté à la variante de base — basculez les autres colonnes depuis là.',

  // Combo builder
  'addDish.comboBuilder.title': 'Créateur de combo',
  'addDish.comboBuilder.description': 'Regroupez plats, boissons et suppléments existants à un prix fixe unique. Les calories et allergènes sont agrégés automatiquement.',
  'addDish.comboBuilder.price.label': 'Prix du combo',
  'addDish.comboBuilder.price.placeholder': 'ex. 12,50',
  'addDish.comboBuilder.price.note': 'Prix fixe unique facturé pour l\'ensemble du combo.',

  // Form actions
  'addDish.formActions.cancel': 'Annuler',
  'addDish.formActions.save': 'Enregistrer {type}',
  'addDish.formActions.update': 'Mettre à jour {type}',
  'addDish.formActions.saveDraft': 'Enregistrer comme brouillon',
  'addDish.formActions.saving': 'Enregistrement...',

  // Validation
  'addDish.validation.header': 'Veuillez corriger les éléments suivants :',
  'addDish.validation.nameRequired': 'Le nom du plat est requis.',
  'addDish.validation.locationsRequired': 'Sélectionnez au moins un emplacement.',
  'addDish.validation.liquorTypeRequired': 'Choisissez un type d’alcool (Spiritueux, Bière, Vin…).',
  'addDish.validation.comboEmpty': 'Le combo doit inclure au moins un article (plat, boisson ou supplément).',
  'addDish.validation.comboPrice': 'Le prix du combo doit être supérieur à 0.',
  'addDish.validation.variantDisplayName': '{row} : le nom affiché est requis.',
  'addDish.validation.variantSize': '{row} : la taille est requise.',
  'addDish.validation.variantUnit': '{row} : l\'unité est requise.',
  'addDish.validation.variantPrice': '{row} : un prix unitaire supérieur à 0 est requis (ou marquez-le comme saisonnier).',
  'addDish.validation.addonPrice': '{row} : le prix doit être 0 ou plus.',
  'addDish.validation.addonMatrixPrice': 'Accompagnement « {addon} » : saisissez un prix supérieur à 0 pour chaque variante.',
  'addDish.validation.baseNormalPrice': 'La variante de base doit avoir un prix Normal (supérieur à 0) pour chaque emplacement sélectionné.',
  'addDish.validation.addonDietRequired': 'Choisissez un régime (Végé / Non-végé / Végan) pour cet accompagnement.',
  'addDish.validation.pieces': '{row} : le nombre de pièces doit être au moins 1.',
  'addDish.validation.variantDuplicate': 'Deux variantes ne peuvent pas porter le nom « {name} ». Donnez un nom unique à chaque variante.',
  'addDish.validation.nameDuplicate': 'Un plat nommé « {name} » existe déjà. Choisissez un nom unique.',
  'addDish.validation.variantPrefix': 'Variante {n}',

  // Toasts
  'addDish.toast.success': 'Succès',
  'addDish.toast.dishCreatedSuccess': 'Plat créé avec succès',
  'addDish.toast.dishUpdatedSuccess': 'Plat mis à jour avec succès',
  'addDish.toast.error': 'Erreur',
  'addDish.toast.failedSave': 'Échec de l\'enregistrement du plat',

  // Locations picker
  'addDish.locations.search.placeholder': 'Rechercher des branches…',
  'addDish.locations.selectAll.tooltip.allSelected': 'Désélectionner toutes les branches',
  'addDish.locations.selectAll.tooltip.empty': 'Sélectionner toutes les branches',
  'addDish.locations.empty': 'Aucune branche — ajoutez-en sous Paramètres → Emplacements.',
  'addDish.locations.noMatches': 'Aucun résultat.',
  'addDish.locations.primary': 'PRINCIPALE',
  'addDish.locations.selectAllLabel': 'Tout sélectionner',
  'addDish.locations.selectAllAriaLabel': 'Sélectionner toutes les branches',

  // Recommendations picker
  'addDish.recPicker.search': 'Rechercher pour ajouter…',
  'addDish.recPicker.selectedSuffix': 'sélectionné(s)',
  'addDish.recPicker.noMatches': 'Aucun résultat.',

  // Variant modals
  'addDish.variantModal.pricing.title': 'Tarification — {variant}',
  'addDish.variantModal.complimentary.title': 'Articles offerts — {variant}',
  'addDish.variantModal.recipe.title': 'Recette — {variant}',
  'addDish.variantModal.cancel': 'Annuler',
  'addDish.variantModal.save': 'Enregistrer',
  'addDish.variantPrice.label': 'Prix',
  'addDish.variantPrice.placeholder': '0,00',
  'addDish.variantPrice.seasonal': 'Saisonnier — sans prix fixe (à fixer le jour même)',
  'addDish.variantPrice.takeawayInstructions': 'Instructions à emporter',
  'addDish.variantPrice.takeawayPlaceholder': 'ex. Emballer la sauce séparément, double emballage, couverts dessus…',
  'addDish.variantRecipe.empty': 'Aucune quantité d\'ingrédient pour cette variante. Ajoutez une ligne ci-dessous.',
  'addDish.variantRecipe.ingredient.placeholder': 'Choisir un ingrédient',
  'addDish.variantRecipe.ingredient.allUsed': 'Tous les ingrédients sont utilisés.',
  'addDish.variantRecipe.quantity.placeholder': 'Qté',
  'addDish.variantRecipe.unit.placeholder': 'g / ml / pcs',
  'addDish.variantRecipe.addRow': 'Ajouter une ligne d\'ingrédient',
  'addDish.variantRecipe.noIngredientsMaster': 'Aucun ingrédient dans la liste de référence — créez-en d\'abord.',

  // Master-create dialog
  'addDish.masterDialog.size.title': 'Ajouter une taille',
  'addDish.masterDialog.size.cta': 'Créer la taille',
  'addDish.masterDialog.unit.title': 'Ajouter une unité',
  'addDish.masterDialog.unit.cta': 'Créer l\'unité',
  'addDish.masterDialog.tag.title': 'Ajouter une étiquette',
  'addDish.masterDialog.tag.cta': 'Créer l\'étiquette',
  'addDish.masterDialog.category.title': 'Ajouter une catégorie',
  'addDish.masterDialog.category.cta': 'Créer la catégorie',
  'addDish.masterDialog.subcategory.title': 'Ajouter une sous-catégorie',
  'addDish.masterDialog.subcategory.cta': 'Créer la sous-catégorie',
  'addDish.masterDialog.nonveg.title': 'Ajouter un type non-végé',
  'addDish.masterDialog.nonveg.cta': 'Créer le type non-végé',
  'addDish.masterDialog.allergen.title': 'Ajouter un allergène',
  'addDish.masterDialog.allergen.cta': 'Créer l\'allergène',
  'addDish.masterDialog.ingredient.title': 'Ajouter un ingrédient',
  'addDish.masterDialog.ingredient.cta': 'Créer l\'ingrédient',
  'addDish.masterDialog.cookingStation.title': 'Ajouter un poste de cuisson',
  'addDish.masterDialog.cookingStation.cta': 'Créer le poste de cuisson',
  'addDish.masterDialog.platingNote.title': 'Ajouter une note de dressage',
  'addDish.masterDialog.platingNote.cta': 'Créer la note de dressage',
  'addDish.masterDialog.servingVessel.title': 'Ajouter une vaisselle de service',
  'addDish.masterDialog.servingVessel.cta': 'Créer la vaisselle de service',
  'addDish.masterDialog.cutlery.title': 'Ajouter des couverts à emporter',
  'addDish.masterDialog.cutlery.cta': 'Créer les couverts',
  'addDish.masterDialog.form.name': 'Nom',
  'addDish.masterDialog.form.description': 'Description',
  'addDish.masterDialog.form.optional': 'Facultatif',
  'addDish.masterDialog.form.allergen': 'Allergène',
  'addDish.masterDialog.form.allergenTooltip': 'Marquer cet ingrédient comme allergène',
  'addDish.masterDialog.form.cancel': 'Annuler',
  'addDish.masterDialog.form.submitting': 'Création…',
  'addDish.masterDialog.validation.nameRequired': 'Le nom est requis',
  'addDish.masterDialog.error.internal': 'Erreur interne',
  'addDish.masterDialog.error.noRestaurant': 'Aucun restaurant sélectionné',
  'addDish.masterDialog.error.noRestaurantDesc': 'Impossible de créer un ingrédient sans contexte de restaurant.',
  'addDish.masterDialog.error.createFailed': 'Échec de la création',
  'addDish.masterDialog.success': 'créé(e)',
  'addDish.tax.excl': 'Prix hors taxe',
  'addDish.tax.incl': 'Prix taxe comprise',
  'addDish.tax.exclNote': 'Les prix ci-dessous sont ce que vous encaissez : {taxes} s’ajoute par-dessus et le client paie davantage.',
  'addDish.tax.inclNote': 'Les prix ci-dessous sont ce que le client paie : {taxes} y est déjà comprise.',
  'addDish.tax.defaultNote': 'Aucune taxe choisie : la taxe par défaut (Paramètres → Taxes) s’applique au paiement.',
  'addDish.tax.cellLine': 'HT {net} · TTC {gross}',

  /* Voir en.js : le message distingue bien l’écran en panne du reste de
     l’application, qui continue de fonctionner. */
  'error.title': 'Cet écran a rencontré un problème',
  'error.body': 'Rien n’a été perdu et le reste de RestoBOXX fonctionne. Rechargez cet écran ou revenez en arrière — si le problème persiste, transmettez les détails ci-dessous au support.',
  'error.details': 'Ce qui a échoué',
  'error.reload': 'Recharger cet écran',
  'error.back': 'Revenir en arrière',
  'error.copy': 'Copier les détails',
};

export default fr;
